import { type AxiosResponse } from 'axios';

import {
  ResReadPoolRewardListType,
  UserAddrAndContractAddrType,
  type ResReadPoolListType,
} from '@/types/pool/read-type';

import { axiosGet, axiosPost } from '@/api/AxiosApi';
import { sendRequest } from '@/api/AxiosRequest';
import { axiosErrors, type CustomAxiosResponse } from '@/api/AxiosResponse';

export const readPoolListByCode = async (): Promise<CustomAxiosResponse<ResReadPoolListType[]> | AxiosResponse> => {
  const code = sessionStorage.getItem('code');
  if (!code) {
    return axiosErrors('empty code', 'readPoolList');
  }
  const payload = {
    path: '/staking-setting/list-code',
    body: { admin_code: code },
  };
  return sendRequest(payload, 'readPoolList', axiosPost);
};

// 풀 세팅 정보
export const readByPoolId = async (
  poolId: string,
): Promise<CustomAxiosResponse<ResReadPoolListType[]> | AxiosResponse> => {
  const payload = {
    path: `/staking-setting/${poolId}`,
  };
  return sendRequest(payload, 'readByPoolId', axiosGet);
};

// 풀 리워드 세팅리스트
export const readPoolRewardSettingList = async (
  poolId: string,
): Promise<CustomAxiosResponse<ResReadPoolRewardListType[]> | AxiosResponse> => {
  const payload = {
    path: `/staking-setting-reward/list`,
    body: { pool_id: poolId },
  };
  return sendRequest(payload, 'readPoolRewardList', axiosPost);
};

// 풀 예상 보상 수량 및 금액
export const readPoolExpectAmtUsdt = async (poolId: string) => {
  const payload = {
    path: `/staking-setting-reward/tot-expect`,
    body: { pool_id: poolId },
  };
  return sendRequest(payload, 'readPoolExpectAmtUsdt', axiosPost);
};

// 풀의 타이틀만 가져온다.
export const readTitle = async (poolId: string) => {
  const payload = {
    path: `/staking-setting/title`,
    body: { pool_id: poolId },
  };
  return sendRequest(payload, 'readTitle', axiosPost);
};

// 풀과 타이틀을 가져온다.
export const readTitlePoolId = async () => {
  const payload = {
    path: `/staking-setting/list-title-pool`,
    body: {},
  };
  return sendRequest(payload, 'readTitlePoolId', axiosPost);
};

// 사용자 예상 리워드 보상 내역 조회
export const userEstimateList = async (poolId: string) => {
  const payload = {
    path: `/user-estimate-rewards/list`,
    body: { poolId },
  };
  return sendRequest(payload, 'userEstimateList', axiosPost);
};

// find-missing-user
export const findMissingUserInfo = async (userAddrAndContractAddrType: UserAddrAndContractAddrType) => {
  const payload = {
    path: `/staking-admins/find-missing-user`,
    body: { ...userAddrAndContractAddrType },
  };
  return sendRequest(payload, 'findMissingUserInfo', axiosPost);
};
